module.exports = __webpack_public_path__ + "dash_20_app_assets/img/paymentmethods.34130d2a.png";